<template>
  <base-label :class="labelClass" :for="name">
    {{ label }} <icon-asterisk v-if="required" class="w-2 h-2 mb-2 inline" />
    <input
      ref="input"
      :type="type"
      :name="name"
      :value="modelValue"
      :oninput="
        event => {
          event.preventDefault()
          const val = (event?.target as HTMLInputElement).value || ''
          emit('update:modelValue', type === 'number' ? parseInt(val) : val)
        }
      "
      v-bind="$attrs"
      :placeholder="placeholder"
      :autocomplete="autocomplete ? 'on' : 'off'"
      class="block p-3 w-full bg-white border rounded-sm"
      :class="{
        'mt-2 sm:mt-4': label,
        empty: modelValue == undefined || modelValue == '',
      }"
      :max="max || ''"
    />
    <p v-if="error" class="text-error font-medium text-sm">{{ error }}</p>
  </base-label>
</template>

<script lang="ts">
export default { inheritAttrs: false }
</script>

<script setup lang="ts">
import IconAsterisk from '@/components/icons/IconAsterisk.vue'
import { computed } from 'vue'

const props = withDefaults(
  defineProps<{
    error: string
    autocomplete: boolean
    modelValue: string | number
    label?: string
    labelClass?: string
    required?: boolean
    placeholder: string
    type?:
      | 'date'
      | 'email'
      | 'number'
      | 'password'
      | 'search'
      | 'tel'
      | 'text'
      | 'url'
    max?: string
    min?: string
  }>(),
  {
    required: false,
    placeholder: '',
    type: 'text',
  }
)

const name = computed(() => {
  return props.label?.toLowerCase()
})

const emit = defineEmits<{
  (e: 'update:modelValue', value: string | number): void
}>()
</script>

<style scoped>
@reference "../../assets/stylesheets/index.css";

input[type='date'] {
  @apply h-12 items-center justify-start;
}

@supports (-webkit-touch-callout: none) {
  input[type='date'] {
    -webkit-min-logical-width: calc(100% - 16px);
    @apply flex;
  }

  input::-webkit-date-and-time-value {
    @apply text-left;
  }

  input[type='date'].empty:not(:focus)::before {
    content: attr(placeholder);
    @apply text-secondary2 pointer-events-none absolute;
  }
}
</style>
